import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { toast } from 'react-toastify';
import moment from 'moment';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input';
import { Link } from 'react-router-dom';

const Completed = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [cnicModal, setCnicModal] = useState(false);
  const [selectedCnicImage, setSelectedCnicImage] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const filteredCourses = teachers.filter((course) => {
    const matchesSearchQuery =
      course?.studentName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course?.teacher?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course?.courseName?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesSearchQuery;
  });

  useEffect(() => {
    fetchTeachers();
  }, [currentPage]);

  const fetchTeachers = () => {
    setLoading(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/students?status=completed&page=${currentPage}&limit=15`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setTeachers(result?.data || []);
        setTotalPages(result?.totalPages || Math.ceil(result?.totalStudents / 6) || 1);

        setLoading(false);
      })
      .catch((error) => {
        toast.error('Failed to fetch teachers');
        setLoading(false);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeStatus = async (newStatus, teacherId) => {
    setTeachers((prevTeachers) =>
      prevTeachers.map((teacher) =>
        teacher._id === teacherId ? { ...teacher, isLoading: true } : teacher
      )
    );

    try {
      const res = await axios.patch(
        `https://quran-backend-theta.vercel.app/v1/admin/update-enrollment-status/${teacherId}`,
        {
          newStatus: newStatus
        }
      );

      if (res.data.success) {
        setTeachers((prevTeachers) =>
          prevTeachers.map((teacher) =>
            teacher._id === teacherId
              ? { ...teacher, status: newStatus, isLoading: false }
              : teacher
          )
        );
      } else {
        // console.error(res.data.message);
      }
    } catch (error) {
      // console.error('Error updating status:', error);
    } finally {
      setTeachers((prevTeachers) =>
        prevTeachers.map((teacher) =>
          teacher._id === teacherId ? { ...teacher, isLoading: false } : teacher
        )
      );
    }
  };

  const ApproveFee = (link) => {
    setIsModelLoading(true);

    const requestOptions = {
      method: 'PATCH',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/fee-mark-paid/${link?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.success === false) {
          toast.error(result?.error);
        } else {
          toast.success('Fee is Paid');
          window.location.reload();
        }
      })
      .catch((error) => {
        toast.error(error);
      })
      .finally(() => {
        setIsModelLoading(false);
      });
  };

  const closeModal = () => {
    setIsSlipModalOpen(false);
  };

  const handleCnicClick = (cnicImage) => {
    setSelectedCnicImage(cnicImage);
    setCnicModal(true);
  };

  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by name ,teacher or course...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <div className="flex justify-between items-center">
        <div>
          <h2 className="main_title">Completed</h2>
          <p className="text-[#1C1D1D]">Here are the details of all Completed</p>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <section className="mb-20 mt-7">
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          <th className="text-sm text-primary font-bold px-6 py-4">Sr No.</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">ID</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Phone no</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Country</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Teacher</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Timing</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Course Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Payment</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCourses.map((teacher, index) => {
                          return (
                            <tr key={teacher?._id} className="bg-white shadow-lg mt-6 rounded-lg">
                               <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                            <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                              {`${index+1}`}
                            </span>
                          </td>
                          {/* ID */}
                          <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                            <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                              {teacher?.student?.studentId}
                            </span>
                          </td>
                              <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                                              <Link   to={`/enroll-student-details/${teacher?.course}/${teacher?.email}`} className="bg-green-200 text-base   text-secondary py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                                                {teacher?.studentName}
                                                              </Link>
                                                            </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.number}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.country}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.teacher?.name}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                {teacher?.assignmentDetails?.timeSlots?.map((item, index) => (
                                  <div key={index}>
                                    {item?.startTime} - {item?.endTime}
                                  </div>
                                ))}
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.courseName}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                {teacher?.feeStatus?.status === '-' ? (
                                  <span
                                    className="text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap"
                                    style={{
                                      color: moment().isAfter(moment(teacher?.nextPaymentDate))
                                        ? 'red'
                                        : 'text-secondary'
                                    }}
                                  >
                                    {teacher?.nextPaymentDate
                                      ? moment(teacher?.nextPaymentDate).format('MMM Do YY')
                                      : 'N/A'}
                                  </span>
                                ) : teacher?.feeStatus?.status === 'paid' ? (
                                  (() => {
                                    const slipPayDate = moment(teacher?.feeStatus?.slipPayDate);
                                    const nextPaymentDate = moment(teacher?.nextPaymentDate);
                                    const diffDays = nextPaymentDate.diff(slipPayDate, 'days');

                                    return (
                                      <span
                                        style={{
                                          color:
                                            diffDays > 30 || moment().isAfter(nextPaymentDate)
                                              ? 'red'
                                              : 'inherit'
                                        }}
                                        className="text-base"
                                      >
                                        {moment(teacher?.nextPaymentDate).format('MMM Do YY')}
                                      </span>
                                    );
                                  })()
                                ) : (
                                  <a
                                    onClick={() => {
                                      setIsSlipModalOpen(true);
                                      setSingleData(teacher);
                                    }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-base text-[#FF7E00] cursor-pointer"
                                  >
                                    Approve Fee Slip
                                  </a>
                                )}
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                {teacher?.isLoading ? (
                                  <span className="ml-2 text-gray-500">Loading...</span>
                                ) : (
                                  <span
                                    className={`text-base py-1 px-2.5 leading-none whitespace-nowrap rounded-md ${
                                      teacher.status === 'pending'
                                        ? 'bg-[#FFF3E0] text-[#FFA500]'
                                        : teacher.status === 'completed'
                                          ? 'bg-[#FFE4E4] text-[#FF0000]'
                                          : teacher.status === 'approved'
                                            ? ' bg-[#DFF7E3] text-[#23A118]'
                                            : teacher.status === 'inactive'
                                              ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                              : 'bg-gray-200 text-black'
                                    }`}
                                  >
                                    {teacher.status}
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex justify-end mt-4 items-center">
  <button
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Previous
  </button>
  
  <span className="mx-4 py-2">
    Page {currentPage} of {totalPages}
  </span>
  
  <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    className="mx-2 px-3 py-2 border rounded bg-white"
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <option key={page} value={page}>
        {page}
      </option>
    ))}
  </select>
  
  <button
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Next
  </button>
</div>
        </section>
      )}

      {isSlipModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={closeModal}
        >
          <div
            className="bg-white p-6 rounded overflow-y-auto h-[60vh] shadow-lg max-w-xl w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
            >
              ✕
            </button>
            <h2 className="text-lg font-bold mb-4">Fee Slip</h2>
            <div className="w-full mb-6">
              <img
                src={singleData?.feeStatus?.slipUrl}
                alt="Fee Slip"
                className="w-full h-auto rounded mb-4"
              />
            </div>
            <div className="flex justify-end gap-4">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => ApproveFee(singleData)}
                className="px-4 py-2 bg-[#FF7E00] text-white rounded"
                disabled={isModelLoading}
              >
                {isModelLoading ? (
                  <div className="spinner-border animate-spin w-5 h-5 border-t-2 border-white rounded-full" />
                ) : (
                  'Approve'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {cnicModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-xl relative max-w-sm w-full">
            {selectedCnicImage && (
              <img src={selectedCnicImage} alt="CNIC" className="w-full h-auto mb-4" />
            )}
            <div className="flex justify-end">
              <button
                onClick={() => setCnicModal(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default Completed;
